import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_WIDTH = 24;
const DEFAULT_HEIGHT = 24;
const DEFAULT_COLOR = '#007C92';

const Support = ({ width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT, color = DEFAULT_COLOR,onClick, ...props }) => {
  return (
    <svg
      {...props} onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.125 12C1.125 18.0061 5.9939 22.875 12 22.875C18.0061 22.875 22.875 18.0061 22.875 12C22.875 5.9939 18.0061 1.125 12 1.125C5.99391 1.125 1.125 5.9939 1.125 12Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.625 8.99975C8.62533 7.28339 9.91354 5.8406 11.6187 5.64681C13.3239 5.45301 14.9029 6.56994 15.2883 8.24245C15.6737 9.91497 14.7427 11.6104 13.1247 12.1825C12.4502 12.421 11.9994 13.059 11.9997 13.7745L11.9997 14.0625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0527 17.4375C11.7906 17.4375 11.5781 17.65 11.5781 17.9121C11.5781 18.1742 11.7906 18.3867 12.0527 18.3867C12.3149 18.3867 12.5273 18.1742 12.5273 17.9121C12.5273 17.65 12.3149 17.4375 12.0527 17.4375V17.4375"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Support;

Support.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func,
  color:PropTypes.any
};